import { FormContextValues } from '@dreryk/react-common';
import { Message, MessageType } from '@dreryk/react-components';

import { guardiansTranslationKeys } from '../../../translations';
import { ContactDetailsSection } from '../GuardianDetailsModal/sections/ContactDetailsSection';

import { GuardianContactDataModalFormBean } from './GuardianModalConfirmButton.types';
import { StyledGuardianAddressFormContent } from './StyledGuardianAddressFormContent';

type GuardianAddressFormContentProps = Pick<FormContextValues<GuardianContactDataModalFormBean>, 'register' | 'watch'>;

export const GuardianAddressFormContent = (props: GuardianAddressFormContentProps): JSX.Element => (
   <StyledGuardianAddressFormContent>
      <Message
         type={MessageType.WARNING}
         displayIndicator
         label={guardiansTranslationKeys.requiredAddressDataForStatutoryRepresentative}
         testId={'requiredAddressDataForStatutoryRepresentative'}
      />
      <ContactDetailsSection register={props.register} watch={props.watch} statutoryRepresentative />
   </StyledGuardianAddressFormContent>
);
